// extracted by mini-css-extract-plugin
export const footer = "AccountSettingsModule__footer__CICpS";
export const form = "AccountSettingsModule__form__mUcA5 Form__form__XFgYc";